module.exports = __webpack_public_path__ + "static/media/video-nosound.f572f711.mp4";